"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../core/collapse"));
var _button = _interopRequireDefault(require("../../core/button"));
var _modal = _interopRequireDefault(require("../../core/modal"));
var _submit = _interopRequireDefault(require("../../core/submit"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _input = _interopRequireDefault(require("../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newDefaultRace: {
    tierRef: null,
    eventRef: null,
    isMultiClass: false,
    showPaddlerRanking: false,
    raceName: null,
    simplySlalomName: null,
    siwiCode: null
  },
  isOpened: false,
  isSubmitting: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Competition Division");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Event");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Race Name");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "SimplySlalom Name");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Siwi Code");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Multi-Class");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Show Paddler Ranking");
class AddDefaultRace extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onCancelNewDefaultRace", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newDefaultRace: {
          ...this.state.newDefaultRace,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.setState({
        isSubmitting: true
      });
      this.props.addDefaultRace(this.state.newDefaultRace).then(result => {
        if (result && result.error) {
          this.setState({
            errorMessage: result.error,
            isSubmitting: false
          });
        } else {
          this.setState(initialState);
        }
      });
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        errorMessage: null
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Default Race' : 'Add Default Race'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onErrorDismissed
      }, "OK"),
      onClose: this.props.onErrorDismissed
    }, "this.state.errorMessage") : /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "tier",
      value: this.state.newDefaultRace.tierRef,
      onChange: this._setValue.bind(this, 'tierRef'),
      clearable: false,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "event",
      value: this.state.newDefaultRace.eventRef,
      onChange: this._setValue.bind(this, 'eventRef'),
      clearable: false,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "raceName",
      value: this.state.newDefaultRace.raceName,
      onChange: this._setValue.bind(this, 'raceName'),
      maxLength: 25,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "simplySlalomName",
      value: this.state.newDefaultRace.simplySlalomName,
      onChange: this._setValue.bind(this, 'simplySlalomName'),
      maxLength: 25,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "siwiCode",
      value: this.state.newDefaultRace.siwiCode,
      onChange: this._setValue.bind(this, 'siwiCode'),
      maxLength: 10
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state.newDefaultRace.isMultiClass,
      onChange: this._setValue.bind(this, 'isMultiClass'),
      maxLength: 10
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state.newDefaultRace.showPaddlerRanking,
      onChange: this._setValue.bind(this, 'showPaddlerRanking'),
      maxLength: 10
    }))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Add Default Race"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancelNewDefaultRace
    }, "Cancel")))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(AddDefaultRace, undefined, (client, props) => ({
  addDefaultRace(newDefaultRace) {
    return client.update('DefaultRace.create', newDefaultRace);
  }
}));